import { combineReducers } from "redux";
import surveyReducer from "./surveyReducer";
import simulationReducer from "./simulationReducer";

const surveyManagerdReducer = combineReducers({
	surveyManager: surveyReducer,
	simulationManager: simulationReducer,
});

export default surveyManagerdReducer;



// WEBPACK FOOTER //
// src/redux/reducers/surveyReducer/index.js